<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Crawl data</h5>
        </div>
       
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <div class="text-center">
                  <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Email</th>
                      <th>Import data from</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      
                    >
                      <td>1</td>
                      <td>experimentslabs@ahaslides.com</td>
                      
                      <td><a href="https://github.com/el-cms/Open-trivia-database" class="pointer" target="_blank">https://github.com/el-cms/Open-trivia-database</a></td>
                      <!-- <td>
                        <button class="btn btn-primary" @click="startImportDataFromElCms" :disabled="loadingElCms">Start Import <i class="fa fa-spin fa-spinner" v-if="loadingElCms"></i></button>
                      </td> -->
                    </tr>
                    <tr
                      
                    >
                      <td>2</td>
                      <td>wwtbam@ahaslides.com</td>
                      <td><a href="https://pastebin.com/QRGzxxEy" class="pointer" target="_blank">https://pastebin.com/QRGzxxEy</a></td>
                      <!-- <td>
                        <button class="btn btn-primary" @click="startImportDataFromWWTBAM" :disabled="loadingWWTBAM">Start Import <i class="fa fa-spin fa-spinner" v-if="loadingElCms"></i></button>
                      </td> -->
                    </tr>
                    <tr v-for="(item, index) in data" :key="index">
                      <td>{{index + 3}}</td>
                      <td>{{item.email}}</td>
                      <td><a :href="item.link" class="pointer" target="_blank">{{item.link}}</a></td>
                      <td>
                        <button class="btn btn-primary" @click="startImportData(item)" :disabled="item.loading">Start Import <i class="fa fa-spin fa-spinner" v-if="item.loading"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <div class="text-center">
                  <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Email</th>
                      <th>Full Name</th>
                      <th>Created At</th>
                      <th>Status</th>
                      <th>Login</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="index"
                      v-for="(item, index) in users"
                      class="pointer"
                    >
                      <td>{{item.id}}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <span>{{item.email || item.providerUserEmail}}</span>
                          <span class="ml-1 badge badge-primary text-uppercase" v-if="item.plan != 'free'">
                            {{item.plan}}
                          </span>
                        </div>
                      </td>
                      <td>{{item.firstName}} {{item.lastName}}</td>
                      <td>{{item.createdAt | dateTime}}</td>
                      
                     
                      <td>
                        <span v-if="item.active" class="badge badge-success">Active</span>
                        <span v-if="!item.active" class="badge badge-secondary">Inactive</span>
                      </td>
                      <td @click.stop="goToPresenterSide(item)">
                        <i class="fas fa-eye"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config";
import backdoor from '@/services/backdoor'
import _ from 'lodash';

export default {
  name: "CrawlData",
  data() {
    return {
      users: [],
      isLoading: true,
      loadingElCms: false,
      loadingWWTBAM: false,
      data: [
        {
          email: 'hqtrivia@ahaslides.com',
          name: 'HQ Trivia',
          categoryName: 'Trivia Question',
          source: 'https://s3.amazonaws.com/public.ahaslide.com/source-presentations/HQTriviaScribe/db.json',
          link: 'https://www.kaggle.com/datasets/theriley106/hq-trivia-question-database'
        },
        {
          email: 'millionairedb@ahaslides.com',
          name: 'millionairedb',
          categoryName: 'Trivia Questions',
          source: 'https://s3.amazonaws.com/public.ahaslide.com/source-presentations/millionairedb/db.json',
          link: 'https://www.millionairedb.com/questions/pages'
        },
        {
          email: 'jservice@ahaslides.com',
          name: 'jservice',
          categoryName: 'Trivia Questions',
          sources: _.range(94).map((item) => `https://s3.amazonaws.com/public.ahaslide.com/source-presentations/jservice/db-${item}.json`),
          link: 'https://jservice.io'
        },
        {
          email: 'wikipedia@ahaslides.com',
          name: 'Wikipedia',
          categoryName: 'Wikipedia Questions 16/09',
          sources: _.range(21).map((item) => `s3://public.ahaslide.com/source-presentations/wikipedia/16092022/wiki_${item + 1}.json`),
          link: 'https://wikipedia.com'
        },
      ],
    };
  },
  created() {
  },
  mounted() {
    this.getData();
    console.log(this.data[2].sources)
  },

  methods: {
    async getData() {
      const resp = await this.$http.get(Config.api.getUserCrawler)
      this.users = resp.data;
      this.isLoading = false;
    },
    async startImportDataFromElCms() {
      if (this.loadingElCms) return
      this.loadingElCms = true
      try {
        await this.$http
        .post(Config.api.importElCmsPresentation, {})
        this.$toasted.success('Import data from el cms done!');
      } catch (error) {
        this.$toasted.error('Import data from el cms error!');
      }
      this.loadingElCms = false
    },
    async goToPresenterSide(item) {
      if (item.isLoading) return;
      item.isLoading = true;
      this.users.push()
      try {
        await backdoor.openPresenterAs(item.id)
      } finally {
        item.isLoading = false;
        this.users.push()
      }
    },

    async startImportDataFromWWTBAM() {
      if (this.loadingWWTBAM) return
      this.loadingWWTBAM = true
      try {
        await this.$http
        .post(Config.api.importWWTBAMPresentation, {})
        this.$toasted.success('Import data from WWTBAM!');
      } catch (error) {
        this.$toasted.error('Import data from WWTBAM!');
      }
      this.loadingWWTBAM = false
    },
    async startImportData(item) {
      if (item.loading) return
      item.loading = true
      this.data.push()
      if (!item.sources) {
        try {
          await this.$http
          .post(Config.api.importDataPresentation, item)
          this.$toasted.success(`Import data from ${item.email} done`);
        } catch (error) {
          this.$toasted.error(`Import data from ${item.email} fail`);
        }
      } else {
        let index = 0;
        const runImport = async() => {
          if (index === item.sources.length) {
            item.loading = false
            this.data.push()
            return
          }
          const payload = JSON.parse(JSON.stringify(item))
          payload.source = item.sources[index]
          if (index) {
            payload.categoryName += ` ${index}`
          }
          try {
            await this.$http
            .post(Config.api.importDataPresentation, payload)
            this.$toasted.success(`Import data from ${payload.email} done`);
          } catch (error) {
            this.$toasted.error(`Import data from ${payload.email} fail`);
          }
          index++
          runImport()
        }
        runImport()
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
